function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import { axiosInstance, createAxiosInstance } from '@applyboard/ui-utils';
import generalRequest, { fetchUrl } from "./generalRequest";
import { API_APPLICATION_PREFIX } from "../constants/consts";
function each(
// eslint-disable-line @typescript-eslint/no-explicit-any
obj, callback) {
  if (!obj) return;
  if (_typeof(obj) !== 'object') return;
  if (Array.isArray(obj)) {
    obj.forEach(function (k, i) {
      return callback(k, i);
    });
  }
  Object.keys(obj).forEach(function (key) {
    return callback(obj[key], key);
  });
}

// Duplicated from ab-common
export var createApplicationNoteRequest = function createApplicationNoteRequest(applicationId, noteData, onProgress) {
  var customAxiosInstance = createAxiosInstance({
    file: true,
    onUploadProgress: onProgress
  });
  return customAxiosInstance.post("".concat(API_APPLICATION_PREFIX, "/").concat(applicationId, "/notes"), noteData);
};

// Duplicated from ab-common
export var patchApplicationDateRequest = function patchApplicationDateRequest(applicationId, mainIntakeId, intake, eslIntakeId, intake_esl) {
  var esl_actual_start_date = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
  var program_actual_start_date = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
  var esl_alternate_actual_start_date = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : null;
  var program_alternate_actual_start_date = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : null;
  return axiosInstance.patch("".concat(API_APPLICATION_PREFIX, "/").concat(applicationId, "/intake"), {
    intake: intake,
    intake_esl: intake_esl,
    main_intake_id: mainIntakeId,
    esl_intake_id: eslIntakeId,
    esl_actual_start_date: esl_actual_start_date,
    program_actual_start_date: program_actual_start_date,
    esl_alternate_actual_start_date: esl_alternate_actual_start_date,
    program_alternate_actual_start_date: program_alternate_actual_start_date
  });
};
export var createApplicationNoteRequestMultipart = function createApplicationNoteRequestMultipart(application_id, note_data, files, onProgress) {
  var data = new FormData();
  Object.keys(note_data).filter(function (key) {
    return !!note_data[key];
  }).forEach(function (key) {
    data.append("note[".concat(key, "]"), note_data[key]);
  });
  if (files && files.length > 0) {
    files.forEach(function (file) {
      data.append('note[attachments][]', file);
    });
  }
  return createApplicationNoteRequest(application_id, data, onProgress);
};
export var getInitialApplicationRequest = function getInitialApplicationRequest(applicationId) {
  return fetchUrl("".concat(API_APPLICATION_PREFIX, "/").concat(applicationId));
};
export var getAdditionalApplicationsRequest = function getAdditionalApplicationsRequest(studentId) {
  return generalRequest("/students/".concat(studentId, "/applications")).then(function (apps) {
    var needExtraInfoFor = ['program', 'school'];
    var requests = [];
    each(apps, function (app) {
      each(needExtraInfoFor, function (idx) {
        var currentApp = app[idx];
        if (!currentApp) {
          console.warn("cannot find information on ".concat(idx));
          return;
        }
        if (currentApp.id) {
          return;
        }
        if (!currentApp.href) {
          console.warn('Not enough info to retrieve object', currentApp);
          return;
        }
        requests.push(generalRequest(app[idx].href).then(function (info) {
          // eslint-disable-next-line no-param-reassign
          app[idx] = info;
        }));
      });
    });
    return Promise.all(requests).then(function () {
      return apps;
    });
  });
};
export var getIsApplicationDismissed = function getIsApplicationDismissed(applicationId) {
  return axiosInstance.get("/api/v2/manual_inspection?application_id=".concat(applicationId));
};
export var postDismissApplication = function postDismissApplication(applicationId) {
  return axiosInstance.post("/api/v2/manual_inspection", {
    application_id: applicationId
  });
};
export var getApplicationRequirementsCompareRequest = function getApplicationRequirementsCompareRequest(applicationId, component) {
  return axiosInstance.get("/api/applications/".concat(applicationId, "/requirement_differences?component=").concat(component));
};
export var updateFlagValue = function updateFlagValue(_ref) {
  var applicationId = _ref.applicationId,
    flagName = _ref.flagName,
    flagValue = _ref.flagValue,
    _ref$payload = _ref.payload,
    payload = _ref$payload === void 0 ? {} : _ref$payload,
    _ref$queryString = _ref.queryString,
    queryString = _ref$queryString === void 0 ? '' : _ref$queryString;
  var endpoint = "".concat(API_APPLICATION_PREFIX, "/").concat(applicationId, "/status?update_type=").concat(flagName).concat(queryString);
  return axiosInstance.patch(endpoint, _objectSpread(_objectSpread({}, payload), {}, {
    flag: flagValue
  }));
};

// Duplicated from ab-common
export var deleteApplication = function deleteApplication(applicationId) {
  return axiosInstance["delete"]("".concat(API_APPLICATION_PREFIX, "/").concat(applicationId));
};
export var deleteApplicationNoteRequest = function deleteApplicationNoteRequest(applicationId, noteId) {
  return axiosInstance["delete"]("".concat(API_APPLICATION_PREFIX, "/").concat(applicationId, "/notes/").concat(noteId));
};